// extracted by mini-css-extract-plugin
module.exports = {"grid":"index-module--grid--2nqZK index-module--grid--qmuSV","description":"index-module--description--UKNDK","title":"index-module--title--3xJ0E"};